/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) 2021 Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { Box, Button, FormControlLabel, TextField, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import RequestAccessFormStyles from './RequestAccessFormStyles';
import { observer } from 'mobx-react';
import { RequestAccessFormViewModel } from './RequestAccessFormViewModel';
import { useViewModel } from '../../../hooks/useViewModel';
import Checkbox from '@material-ui/core/Checkbox';

const RequestAccessForm = observer(() => {
	const classes = RequestAccessFormStyles();
	const viewModel: RequestAccessFormViewModel = useViewModel(RequestAccessFormViewModel);

	return (
		<>
			<Typography variant={'body2'}>
				<FormattedMessage id='requestAccess.welcome_message' />
			</Typography>
			<Typography className={classes.separator} variant={'h4'}>
				<FormattedMessage id='requestAccess.request_access' />
			</Typography>
			<form
				onSubmit={async (e) => {
					e.preventDefault();
					await viewModel.requestAccess(viewModel.getName(), viewModel.getEMail(), viewModel.getDepartment());
				}}
				onError={(errors) => console.log(errors)}
				className={classes.formRoot}>
				<label id='name' className={classes.label}>
					<FormattedMessage id={'requestAccess.name'} />
				</label>
				<TextField
					required
					name='name'
					variant='outlined'
					fullWidth={true}
					size={'small'}
					value={viewModel.getName()}
					onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => viewModel.setName(e)}
				/>
				<label id='email' className={classes.label}>
					<FormattedMessage id={'requestAccess.e_mail'} />
				</label>
				<TextField
					required
					name='email'
					variant='outlined'
					fullWidth={true}
					size={'small'}
					value={viewModel.getEMail()}
					onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => viewModel.setEMail(e)}
					type='email'
				/>
				<label id='department' className={classes.label}>
					<FormattedMessage id={'requestAccess.department'} />
				</label>
				<TextField
					required
					name='department'
					variant='outlined'
					fullWidth={true}
					size={'small'}
					value={viewModel.getDepartment()}
					onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => viewModel.setDepartment(e)}
				/>
				<Box display={'flex'} justifyContent={'space-between'} alignItems={'flex-start'}>
					<FormControlLabel
						className={classes.checkbox}
						control={
							<Checkbox
								checked={viewModel.getCheckedTos()}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) => viewModel.acceptTos(e)}
								name='checkTos'
								color='secondary'
							/>
						}
						label={<FormattedMessage id='requestAccess.tos' />}
					/>
					<Button disabled={!viewModel.disableRequestButton()} variant='contained' color='secondary' type='submit'>
						<FormattedMessage id='requestAccess.request_access_button' />
					</Button>
				</Box>
			</form>
		</>
	);
});

export default RequestAccessForm;
